module.exports = __webpack_public_path__ + "static/media/Engineering-banner-2x.43cf4d3e.jpg";